import { render, staticRenderFns } from "./TransactionDetailModal.vue?vue&type=template&id=39fee4ba"
import script from "./TransactionDetailModal.vue?vue&type=script&lang=js"
export * from "./TransactionDetailModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports